/**
 * Плагин для отслеживания клика/тача вне элемента с массивом исключений
 * 
 * @param {string|Element} target — селектор или DOM-элемент
 * @param {Array} excludeClasses — массив классов, при клике/таче на которые событие не сработает
 * @param {Function} callback — функция, которая выполнится при клике/таче вне элемента
 */
function clickOutside(target, excludeClasses = [], callback) {
    
    const targetElement =
      typeof target === 'string' ? document.querySelector(target) : target;
  
    if (!targetElement) {
      console.error('clickOutside: Target element not found');
      return;
    }
  
    function handleEvent(event) {
      const clickedInside = targetElement.contains(event.target);
      const clickedOnExcluded = excludeClasses.some(cls =>
        event.target.closest(`.${cls}`)
      );      
  
      if (!clickedInside && !clickedOnExcluded) {
        callback();
      }
    }
  
    document.addEventListener('click', handleEvent);
    document.addEventListener('touchstart', handleEvent);
  
    // Функция для удаления обработчиков
    return () => {        
      document.removeEventListener('click', handleEvent);
      document.removeEventListener('touchstart', handleEvent);
    };
  }